(function ($) {
  /** new link tab artis series landing page **/
  $("#block-id-text_block_ec3z3c a").attr("target", "_blank");
  $("#block-id-text_block_t4chp3 a").attr("target", "_blank");
  $("#block-id-text_block_d9xTyn a").attr("target", "_blank");

  /*** embroidery START ***/
  function embro_cart_token_old() {
    console.log("Embro 2");
    $.ajax({
      url: "/cart.js",
      type: "GET",
      dataType: "json",
      success: function (data) {
        //console.log("Embro Cart full response:", JSON.stringify(data, null, 2));
        $("#btn-add-Embroidery").attr("data-token", data.token);
        var encodedCookie = encodeURIComponent(document.cookie);
        $("#btn-add-Embroidery").attr("data-cookie", encodedCookie);
      },
      error: function (error) {
        console.log("Error fetching data from API:", error);
      },
    });
  }

  // Stable cart token: Shopify returns different token per GET until item is added
  // After add item, token becomes "stable" and stays the same for the session
  function embro_cart_token() {
    console.log("embro 4");
    var $btn = $("#btn-add-Embroidery");
    if (!$btn.length) return;

    $.ajax({
      url: "/cart.js",
      type: "GET",
      dataType: "json",
      success: function (data) {
        var token = data.token;

        // If token already has ?key=, it's already "stable" (Firefox behavior)
        if (token.indexOf('?key=') !== -1) {
          $btn.attr("data-token", token);
          $btn.attr("data-cookie", encodeURIComponent(document.cookie));
          return;
        }

        // Fresh cart (Edge) - token changes each GET until stabilized
        // Silent add minimal item to stabilize, then remove immediately
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({ id: 15000366678380, quantity: 1 }) // id:0 won't actually add valid item
        }).always(function() {
          // Immediately remove (quantity:0) or clear cart
          $.ajax({
            url: "/cart/clear.js",
            type: "POST",
            dataType: "json",
            contentType: "application/json"
          }).always(function() {
            // Get stabilized token
            $("body").trigger("click");
            $.ajax({
              url: "/cart.js",
              type: "GET",
              dataType: "json",
              success: function (stabilizedData) {
                $btn.attr("data-token", stabilizedData.token);
                $btn.attr("data-cookie", encodeURIComponent(document.cookie));
              },
              error: function() {
                // Fallback to original token if stabilization failed
                $btn.attr("data-token", token);
                $btn.attr("data-cookie", encodeURIComponent(document.cookie));
              }
            });
          });
        });
      },
      error: function (error) {
        console.log("Error fetching data from API:", error);
      },
    });
  }

  if ($("#btn-add-Embroidery").length > 0) {
    embro_cart_token();
  }

  //login embroidery return URL
  // Function to get query parameters
  function getQueryParams() {
    const params = {};
    const queryString = window.location.search.substring(1);
    const regex = /([^&=]+)=([^&]*)/g;
    let m;
    while ((m = regex.exec(queryString))) {
      params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    return params;
  }

  // Get query parameters
  const params = getQueryParams();

  // Check if return_url parameter exists
  if (params.return_url) {
    // Set the value of #return_to with the value of return_url parameter
    $("#return_to").val(params.return_url);
  }
  /*** embroidery END ***/

  $("#template button").click(function (event) {
    if (
      $("div.checkbox-group.required :checkbox:checked").length == 0 &&
      $("div.checkbox-group.required").length
    ) {
      event.preventDefault();

      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            document.querySelector(".checkbox-group.required").offsetTop - 175,
        },
        1000
      );
      $(".error-background").delay(1000).fadeIn();
    }
  });

  if ($(".slider-gallery").length) {
    createSlider(".slider-gallery");
    createPopup();
  }
  if ($("#insta-feed").length) {
    if ($("#insta-feed > a").length) {
      createSlider("#insta-feed");
    } else {
      $("#insta-feed").bind("DOMSubtreeModified", function (e) {
        if (e.target.innerHTML.length > 0) {
          if ($("#insta-feed > a").length) {
            $("#insta-feed").unbind("DOMSubtreeModified");
            createSlider("#insta-feed");
          }
        }
      });
    }
  }

  function createSlider(selector) {
    if (selector == ".slider-gallery") {
      $(selector).on("init", function (slick) {
        $(".slider-gallery .slick-slide a").click(function (e) {
          openPopup($(this).attr("href"));
          e.preventDefault();
        });
      });
    }
    $(selector).slick({
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  function createPopup() {
    if ($("body > #popup-slider-gallery").length === 0) {
      $("#popup-slider-gallery").detach().appendTo("body");
      $("main #popup-slider-gallery").remove();
      $("#popup-slider-gallery, #popup-slider-gallery .close-button").click(
        function () {
          closePopup();
        }
      );
    }
  }

  function openPopup(url) {
    $("#popup-slider-gallery").fadeIn();
    var isVideo = url.indexOf("youtube") != -1;
    if (isVideo) {
      $("#popup-slider-gallery").addClass("is-video");
      $("#popup-slider-gallery .video-container").show();
      $("#popup-slider-gallery .image-container").hide();
      var iframe = $("#popup-slider-gallery iframe");
      if (iframe) {
        var urlReplaced =
          url.indexOf("embed/") == -1 ? url.replace("watch?v=", "embed/") : url;
        iframe.attr("src", urlReplaced);
      }
    } else {
      $("#popup-slider-gallery").removeClass("is-video");
      $("#popup-slider-gallery .video-container").hide();
      $("#popup-slider-gallery .image-container").show();
      var image = $("#popup-slider-gallery img");
      if (image) {
        image.attr("src", "");
        image.attr("src", url);
        image.one("load", function () {
          $("#popup-slider-gallery .image-container").addClass("has-content");
        });
      }
    }
  }

  function closePopup() {
    var iframe = $("#popup-slider-gallery iframe");
    if (iframe) {
      iframe.attr("src", "");
    }
    $("#popup-slider-gallery").fadeOut();
    $("#popup-slider-gallery .image-container").removeClass("has-content");
  }

  function initVariantsActions(fromQuickbuy) {
    var parentForm = fromQuickbuy
      ? $(".quickbuy-container .product-form")
      : $(".product-form").first();
    var mainSelectorVal = "";
    parentForm.find(".option-selector").each(function (index) {
      var separator = mainSelectorVal == "" ? "" : " / ";

      if ($(this).find("input[type=radio]:checked").length > 0) {
        var radioVal = $(this).find("input[type=radio]:checked").val();
        if (radioVal.indexOf("-pid-") != -1)
          radioVal = radioVal.split("-pid-")[0];
        mainSelectorVal += separator + radioVal;
      }
    });

    var originalSelectorVal = parentForm
      .find(".original-selector option:contains(" + mainSelectorVal + ")")
      .val();
    var selectedOption = parentForm.find(
      '.original-selector option[value="' + originalSelectorVal + '"]'
    );
    parentForm.find(".label-value").text(selectedOption.data("style-number"));

    console.log("TEST 1");
    // Product select box
    parentForm
      .find(".option-selectors-main .option-selector input[type=radio]")
      .change(function (event) {
        console.log("TEST 1.1");
        var optionSetId = 1;
        if ($(this).parents(".option-name--color").length) { //parent
          console.log("TEST 1.2");
          optionSetId = 0;
          $(this)
            .parents(".product-detail")
            .find(".gallery")
            .removeClass("is-visible");
          $(this)
            .parents(".product-detail")
            .find('.gallery[data-color="' + $(this).val() + '"]')
            .addClass("is-visible");

          $(document).trigger("variantColorChanged", [$(this).val()]);

          //embroidery start
          var optLabel = $('label[for="' + $(this).attr("id") + '"]');
          var dataHandleValue = optLabel.attr("data-handle");
          var dataColor = optLabel.attr("data-swatch").replace(/\s/g, "_");
          var dataCustomer = $("#btn-add-Embroidery").data("customer");
          if (dataCustomer != "" && typeof dataHandleValue !== "undefined") {
            console.log("TEST 2");
            setTimeout(function () {
              var dataToken = $("#btn-add-Embroidery").data("token");
              var dataCookie = $("#btn-add-Embroidery").data("cookie");
              $("#btn-add-Embroidery").attr(
                "href",
                "https://apps.koihappiness.com/embroidery/index.html?shopify_handle=" +
                  dataHandleValue +
                  "&color=" +
                  dataColor +
                  "&customer=" +
                  dataCustomer +
                  "&token=" +
                  dataToken +
                  "&cookie=" +
                  dataCookie
              );
              $(".modal_iframe").attr(
                "src",
                "https://apps.koihappiness.com/embroidery/index.html?shopify_handle=" +
                  dataHandleValue +
                  "&color=" +
                  dataColor +
                  "&customer=" +
                  dataCustomer +
                  "&token=" +
                  dataToken +
                  "&cookie=" +
                  dataCookie
              );
            }, 1000);
          }
          //embroidery end
          $('.cc-accordion-item__content').html($('.product-child-desc-'+ dataHandleValue).html());

          const relatedHandles = optLabel.attr("data-related-handles");
          if (relatedHandles) {
            const relatedHandlesArr = relatedHandles.split('--');
            const allRelatedProducts = $(".related-products [data-product-handle]");
            let foundRelatedProduct = false;
            allRelatedProducts.each(function () {
              if (relatedHandlesArr.includes($(this).attr('data-product-handle'))) {
                foundRelatedProduct = true;
                $(this).removeClass('hidden');
                const newColor = optLabel.attr("data-swatch");
                const optionColorButton = $(this).find('[data-swatch="' + newColor + '"]');
                if (optionColorButton) optionColorButton.click();
              } else {
                $(this).addClass('hidden');
              };
            });
           
            $(".related-products").removeClass('hidden');
          } else $(".related-products").addClass('hidden');

          //pair with
          const pairHandles = optLabel.attr("data-pair-handles");
          if (pairHandles) {
            const pairHandlesArr = pairHandles.split('--');
            const allPairProducts = $(".pair-products [data-product-handle]");
            let foundPairProduct = false;
            allPairProducts.each(function () {
              if (pairHandlesArr.includes($(this).attr('data-product-handle'))) {
                foundPairProduct = true;
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              };
            });
            $(".pair-products").removeClass('hidden');
          } else $(".pair-products").addClass('hidden');
        }
        else{
          console.log("test child")
          //embroidery start
          var optLabel = $('label.opt-label');
          var dataHandleValue = $('.option-selectors-main').attr("data-handle");
          var dataColor = optLabel.attr("data-swatch").replace(/\s/g, "_");
          var dataCustomer = $("#btn-add-Embroidery").data("customer");
          if (dataCustomer != "" && typeof dataHandleValue !== "undefined") {
            console.log("TEST 2");
            setTimeout(function () {
              var dataToken = $("#btn-add-Embroidery").data("token");
              var dataCookie = $("#btn-add-Embroidery").data("cookie");
              $("#btn-add-Embroidery").attr(
                "href",
                "https://apps.koihappiness.com/embroidery/index.html?shopify_handle=" +
                  dataHandleValue +
                  "&color=" +
                  dataColor +
                  "&customer=" +
                  dataCustomer +
                  "&token=" +
                  dataToken +
                  "&cookie=" +
                  dataCookie
              );
              $(".modal_iframe").attr(
                "src",
                "https://apps.koihappiness.com/embroidery/index.html?shopify_handle=" +
                  dataHandleValue +
                  "&color=" +
                  dataColor +
                  "&customer=" +
                  dataCustomer +
                  "&token=" +
                  dataToken +
                  "&cookie=" +
                  dataCookie
              );
            }, 1000);
          }
        }

        if ($(this).parents(".option-name--inseam").length) {
          optionSetId = 2;
          var allSizesArr = [];
          var optionSelectorsMain = $(this)
            .parents(".product-form")
            .find(".option-selectors-main");
          if (optionSelectorsMain.length) {
            var dataSizes = optionSelectorsMain.attr("data-sizes");
            if (typeof dataSizes !== "undefined" && dataSizes !== false) {
              allSizesArr = dataSizes.split(", ");
            }
          }
          var foundOnPositions = [];

          $(this)
            .parents(".product-form")
            .find(".original-selector option:contains(" + $(this).val() + ")")
            .each(function (index) {
              var sizeValue = $(this).text().split(" / ")[1];
              var foundOnPosition = allSizesArr.indexOf(sizeValue);
              if (foundOnPosition != -1 && $(this).attr("data-stock") != "out")
                foundOnPositions.push(foundOnPosition);
            });

          var sortedResults = uniqueNumbers(
            foundOnPositions.sort((a, b) => a - b)
          );
          $(this)
            .parents(".product-form")
            .find(".option-name--size .opt-label")
            .each(function (index) {
              //$(this).css("display", (sortedResults.indexOf(index-1) == -1) ? "none" : "");
              if (sortedResults.indexOf(index - 1) == -1)
                $(this).prev().addClass("disabled-option");
              else $(this).prev().removeClass("disabled-option");
              //setStatusAddToCart( false, parentForm, "unselected" );
              if (
                sortedResults.indexOf(index - 1) == -1 &&
                $(this).prev().is(":checked")
              ) {
                $(this)
                  .parents(".product-form")
                  .find(".option-name--size input")
                  .first()
                  .trigger("click");
                setStatusAddToCart(
                  false,
                  $(this).parents(".product-form"),
                  "unselected"
                );
              }
            });
        }

        var mainSelectorVal = "";
        var productHandle = "";
        var originalSelectorVal = "";
        var colorName = "";
        var parentForm = $(this).parents(".product-form");
        parentForm.find(".option-selector").each(function (index) {
          var separator = mainSelectorVal == "" ? "" : " / ";
          var radioVal = $(this).find("input[type=radio]:checked").val();

          if (radioVal != undefined) {
            if (radioVal.indexOf("-pid-") != -1)
              radioVal = radioVal.split("-pid-")[0];
            mainSelectorVal += separator + radioVal;
            if (index == 0) {
              colorName = radioVal;
              parentForm.find(".label__value").text(colorName);
              if (
                parentForm.find(
                  ".original-selector option:contains(" + colorName + ")"
                ).length
              ) {
                parentForm.find(".label-value").text(
                  parentForm
                    .find(
                      ".original-selector option:contains(" + colorName + ")"
                    )
                    .first()
                    .data("style-number")
                );
              }
            }
          }
        });

        var valToSearch = $(this).val();
        var valToSearch2 = $(this).val();
        var valToSearch3 = $(this).val();
        var optionSetId2 = 0;
        var optionSetId3 = 0;
        if (optionSetId == 0) {
          if (
            parentForm.find(".option-name--size input[type=radio]:checked")
              .length &&
            parentForm
              .find(".option-name--size input[type=radio]:checked")
              .val() != "default"
          ) {
            optionSetId2 = 1;
            valToSearch2 = parentForm
              .find(".option-name--size input[type=radio]:checked")
              .val();
          }
          if (
            parentForm.find(".option-name--inseam input[type=radio]:checked")
              .length &&
            parentForm
              .find(".option-name--inseam input[type=radio]:checked")
              .val() != "default"
          ) {
            optionSetId2 = 2;
            valToSearch2 = parentForm
              .find(".option-name--inseam input[type=radio]:checked")
              .val();
          }
          if (
            parentForm.find(".option-name--size input[type=radio]:checked")
              .length &&
            parentForm
              .find(".option-name--size input[type=radio]:checked")
              .val() != "default" &&
            parentForm.find(".option-name--inseam input[type=radio]:checked")
              .length &&
            parentForm
              .find(".option-name--inseam input[type=radio]:checked")
              .val() != "default"
          ) {
            optionSetId3 = 3;
            valToSearch3 = parentForm
              .find(".option-name--inseam input[type=radio]:checked")
              .val();
          }
        }
        if (
          optionSetId == 1 &&
          parentForm.find(".option-name--color input[type=radio]:checked")
            .length
        )
          valToSearch2 = parentForm
            .find(".option-name--color input[type=radio]:checked")
            .val();
        if (
          optionSetId == 2 &&
          parentForm.find(".option-name--color input[type=radio]:checked")
            .length
        )
          valToSearch2 = parentForm
            .find(".option-name--color input[type=radio]:checked")
            .val();
        var valToSearchId = -1;
        var availableColors = [];
        var availableSizes = [];
        var availableLengths = [];
        var optionsContaining = parentForm
          .find(".original-selector option")
          .filter(function () {
            if ($(this).attr("data-stock") == "out") return;
            var searchIn = $(this).html();
            var shouldCheck =
              searchIn.includes(valToSearch) && searchIn.includes(valToSearch2);
            if (optionSetId3 != 0) {
              var shouldCheck =
                (searchIn.includes(valToSearch) &&
                  searchIn.includes(valToSearch2)) ||
                (searchIn.includes(valToSearch) &&
                  searchIn.includes(valToSearch3));
            }
            if (!$(".option-name--inseam input[type=radio]:checked").length) {
              var shouldCheck = searchIn.includes(valToSearch);
              valToSearch2 = valToSearch;
              optionSetId2 = 0;
            }
            if (shouldCheck) {
              var splitValues = searchIn.split(" / ");
              valToSearchId = splitValues.indexOf(valToSearch);
              if (!availableColors.includes(splitValues[0]))
                if (splitValues[0] != "default")
                  availableColors.push(splitValues[0]);
              if (!availableSizes.includes(splitValues[1]))
                if (splitValues[1] != "default")
                  availableSizes.push(splitValues[1]);
              if (!availableLengths.includes(splitValues[2]))
                if (splitValues[2] != "default")
                  availableLengths.push(splitValues[2]);
            }
            return searchIn.includes(valToSearch);
          });

        if (valToSearchId == 0) {
          if (optionSetId2 != 1) {
            parentForm
              .find(".option-selectors-main .option-name--size input")
              .each(function (index) {
                if (availableSizes.includes($(this).val()))
                  $(this).removeClass("disabled-option");
                else $(this).addClass("disabled-option");
              });
          }
          if (optionSetId2 != 2) {
            parentForm
              .find(".option-selectors-main .option-name--inseam input")
              .each(function (index) {
                if (availableLengths.includes($(this).val()))
                  $(this).removeClass("disabled-option");
                else $(this).addClass("disabled-option");
              });
          }
        }
        if (valToSearchId == 1) {
          parentForm
            .find(".option-selectors-main .option-name--inseam input")
            .each(function (index) {
              if (availableLengths.includes($(this).val()))
                $(this).removeClass("disabled-option");
              else $(this).addClass("disabled-option");
            });
        }
        if (valToSearchId == 2) {
          parentForm
            .find(".option-selectors-main .option-name--size input")
            .each(function (index) {
              if (availableSizes.includes($(this).val()))
                $(this).removeClass("disabled-option");
              else $(this).addClass("disabled-option");
            });
        }

        var optionsMainSelectorVal = parentForm
          .find(".original-selector option")
          .filter(function () {
            return $(this).html() == mainSelectorVal;
          });

        if (optionsMainSelectorVal.length) {
          originalSelectorVal = optionsMainSelectorVal.val();
          parentForm.find(".original-selector").val(originalSelectorVal);
          var selectedOption = parentForm.find(
            '.original-selector option[value="' + originalSelectorVal + '"]'
          );
          setStatusAddToCart(
            selectedOption.attr("data-stock") != "out",
            parentForm
          );
          parentForm.find(".current-price").text(selectedOption.data("price"));
          var dataPriceCompare = selectedOption.data("price-compare");
          if (dataPriceCompare == "") {
            parentForm.find(".price").removeClass("on-sale");
          } else {
            parentForm.find(".price").addClass("on-sale");
          }

          if ($(".colors-on-sale-price").length) {
            if (
              $(".colors-on-sale-price").index() <
              parentForm.find(".opt-btn:checked").index()
            ) {
              parentForm
                .closest(".product-detail")
                .find(".product-label--on-sale")
                .addClass("hidden");
              parentForm
                .closest(".product-detail")
                .find(".product-label--clearance")
                .removeClass("hidden");
            } else {
              parentForm
                .closest(".product-detail")
                .find(".product-label--on-sale")
                .removeClass("hidden");
              parentForm
                .closest(".product-detail")
                .find(".product-label--clearance")
                .addClass("hidden");
            }
          }

          const badgesClearance = parentForm
            .closest(".product-detail")
            .find(".product-label--clearance span");
          if (badgesClearance.length > 0)
            badgesClearance.each(function () {
              $(this).text(
                selectedOption.data("price").includes(".97")
                  ? "Final Sale"
                  : "Clearance"
              );
            });

          parentForm
            .find(".was-price")
            .text(dataPriceCompare == "0" ? "" : dataPriceCompare);
          parentForm.find(".badge-container").removeClass("show-badge");
          if (selectedOption.data("price").includes(".97")) {
            parentForm.find(".badge-container").addClass("show-badge");
          }
          parentForm
            .find(".label-value")
            .text(selectedOption.data("style-number"));
        } else {
          if (mainSelectorVal.indexOf("default") != -1) {
            mainSelectorVal = mainSelectorVal.split(" / ")[0] + " / ";
            var optionStartsWith = parentForm
              .find(".original-selector option")
              .filter(function () {
                return this.textContent.startsWith(mainSelectorVal);
              });
            if (optionStartsWith.length) {
              originalSelectorVal = optionStartsWith[0].value;
              parentForm.find(".original-selector").val(originalSelectorVal);
              var selectedOption = parentForm.find(
                '.original-selector option[value="' + originalSelectorVal + '"]'
              );
              parentForm
                .find(".current-price")
                .text(selectedOption.data("price"));
              var dataPriceCompare = selectedOption.data("price-compare");
              if (dataPriceCompare == "") {
                parentForm.find(".price").removeClass("on-sale");
              } else {
                parentForm.find(".price").addClass("on-sale");
              }

              if ($(".colors-on-sale-price").length) {
                if (
                  $(".colors-on-sale-price").index() <
                  parentForm.find(".opt-btn:checked").index()
                ) {
                  parentForm
                    .closest(".product-detail")
                    .find(".product-label--on-sale")
                    .addClass("hidden");
                  parentForm
                    .closest(".product-detail")
                    .find(".product-label--clearance")
                    .removeClass("hidden");
                } else {
                  parentForm
                    .closest(".product-detail")
                    .find(".product-label--on-sale")
                    .removeClass("hidden");
                  parentForm
                    .closest(".product-detail")
                    .find(".product-label--clearance")
                    .addClass("hidden");
                }
              }

              const badgesClearance = parentForm
                .closest(".product-detail")
                .find(".product-label--clearance span");
              if (badgesClearance.length > 0)
                badgesClearance.each(function () {
                  $(this).text(
                    selectedOption.data("price").includes(".97")
                      ? "Final Sale"
                      : "Clearance"
                  );
                });

              parentForm
                .find(".was-price")
                .text(dataPriceCompare == "0" ? "" : dataPriceCompare);
              parentForm.find(".badge-container").removeClass("show-badge");
              if (selectedOption.data("price").includes(".97")) {
                parentForm.find(".badge-container").addClass("show-badge");
              }
              parentForm
                .find(".label-value")
                .text(selectedOption.data("style-number"));
            }
            setStatusAddToCart(false, parentForm, "unselected");
          } else setStatusAddToCart(false, parentForm, true);
        }
      });

    var selectedOption = parentForm.find(".original-selector option:selected");
    const badgesClearance = parentForm
      .closest(".product-detail")
      .find(".product-label--clearance span");

    if (badgesClearance.length > 0)
      badgesClearance.each(function () {
        $(this).text(
          selectedOption.data("price").includes(".97")
            ? "Final Sale"
            : "Clearance"
        );
      });

    if (
      parentForm.find(
        ".option-selectors-main .option-name--color input[type=radio]:checked"
      ).length &&
      parentForm.find(
        ".option-selectors-main .option-name--size input[type=radio]:checked"
      ).length == 1 &&
      parentForm
        .find(
          ".option-selectors-main .option-name--size input[type=radio]:checked"
        )
        .val() == "default" &&
      !parentForm.find(
        ".option-selectors-main .option-name--inseam input[type=radio]:checked"
      ).length
    ) {
      parentForm
        .find(
          ".option-selectors-main .option-name--color input[type=radio]:checked"
        )
        .trigger("change");
    }

    var crtHref = window.top.location.href;
    if (crtHref.indexOf("variant=") != -1) {
      var variantToDisplay = Number(crtHref.split("variant=")[1]);
      $(".original-selector").val(variantToDisplay);
      $(".original-selector").trigger("change");
      var crtOption = $(
        '.original-selector option[value="' + variantToDisplay + '"]'
      );
      var crtOptions = crtOption.text().split(" / ");
      $(".option-selector__btns").each(function (index) {
        $(this)
          .find('.opt-btn[value="' + crtOptions[index] + '"]')
          .prop("checked", true)
          .trigger("change");
      });
    } 

    const newColorButton = $(".option-selector__btns .opt-btn:checked:first");
    if (newColorButton.length) {
      newColorButton.trigger('change');
    }
    const newColor = newColorButton.next().attr("data-swatch");
    const allRelatedProducts = $(".related-products [data-product-handle]");

    allRelatedProducts.each(function () {
      const optionColorButton = $(this).find('[data-swatch="' + newColor + '"]');

      if (optionColorButton) optionColorButton.click();
    });

    // if ( crtHref.indexOf("selected-handle=") != -1 ) {
    //   var handleToDisplay = crtHref.split("selected-handle=")[1];
    //   $('.option-name--color').find('.opt-label[data-handle="' + handleToDisplay + '"]').first().trigger("click");
    // }
    //indra
    var queryString = window.location.search;
    urlParams = new URLSearchParams(queryString);
    var selectedHandle = urlParams.get("selected-handle");
    if (selectedHandle != -1) {
      var handleToDisplay = selectedHandle;
      $(".option-name--color")
        .find('.opt-label[data-handle="' + handleToDisplay + '"]')
        .first()
        .trigger("click");
    }

    if ($(".just-clearance").length) {
      if (
        $(".just-clearance").index() >
        $(".option-name--color .opt-btn:checked").index()
      ) {
        $(".just-clearance").next().trigger("click");
      }
    }

    if ($(".product-label--on-sale").length) {
      $(".product-label--clearance").addClass("hide");
    }
  }

  if (
    $(".template-collection").length ||
    $(".template-search").length ||
    $(".template-product").length
  ) {
    $(window).on("load", function () {
      initVariantsActions();
    });
  }

  function uniqueNumbers(array) {
    return array.filter(function (v, i, arr) {
      // compare index with first element index
      return i == arr.indexOf(v);
    });
  }

  function setStatusAddToCart(status, parentForm, notAvailable) {
    var $button = parentForm.find(".quantity-submit-row__submit .button");
    if (status) {
      $button.removeAttr("disabled");
      $button.removeClass("disabled-atc");
      $button.text(theme.strings.products_product_add_to_cart);
    } else {
      $button.attr("disabled", "disabled");
      if (notAvailable == "unselected")
        $button.text(theme.strings.products_product_add_to_cart);
      else
        $button.text(
          notAvailable
            ? theme.strings.products_variant_non_existent
            : theme.strings.products_variant_no_stock
        );
    }
  }

  function contentChanged(mutationList) {
    // this function will run each time the content of the DIV changes
    const parentBlock = mutationList[0].target.closest(".product-block, .collection-slider-row");

    if (parentBlock) {
      if (mutationList.length > 1) {
        if (!parentBlock.classList.contains("quickbuy-initialized")) {
          var selection = document.querySelector(
            ".quickbuy-container .main-product-variants"
          );
          if (selection !== null) {
            initVariantsActions(true);
          }
          parentBlock.classList.add("quickbuy-initialized");
        }
      } else  {
        parentBlock.classList.remove("quickbuy-initialized");
      }
    }
  }

  function watchForQuickbuy() {
    var quickbuyContainers = document.querySelectorAll(".quickbuy-container");

    const observer = new MutationObserver((mutationList) => {
      contentChanged(mutationList);
    });

    quickbuyContainers.forEach((quickbuyContainer) => {
      observer.observe(quickbuyContainer, { childList: true, subtree: true });
    });
  }

  /* ============== Filetring ============== */

  function getCheckboxesList(selector) {
    var productsWithColors = $(
      ".product-filtering-info[data-option-" + selector + "s]"
    );
    if (productsWithColors.length) {
      var allColorsArr = [];

      var allColorsNames = "";
      var allColorsValues = "";
      productsWithColors.each(function () {
        allColorsNames += $(this).data("option-" + selector + "s-names") + "--";
        allColorsValues += $(this).data("option-" + selector + "s") + "--";
      });

      allColorsNames = allColorsNames.substring(0, allColorsNames.length - 2);
      allColorsValues = allColorsValues.substring(
        0,
        allColorsValues.length - 2
      );

      var allColorsNamesArr = allColorsNames.split("--");
      var allColorsValsArr = allColorsValues.split("--");

      for (var i = 0; i < allColorsNamesArr.length; i++) {
        var colorObj = {};
        colorObj.name = allColorsNamesArr[i];
        colorObj.value = allColorsValsArr[i];
        allColorsArr.push(colorObj);
      }

      let uniqueObjArray = [
        ...new Map(allColorsArr.map((item) => [item["name"], item])).values(),
      ];

      allColorsArr = uniqueObjArray.sort(function (a, b) {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      return allColorsArr;
    }
  }

  function generateCheckboxes(selector, vals) {
    var parentSelector = ".filter-group--" + selector;
    if (vals !== false) {
      if (selector == "inseam" && vals.length > 0) {
        $(parentSelector).removeClass("visually-hidden");
      }
      for (var i = 0; i < vals.length - 1; i++) {
        $(parentSelector + " .filter-group__item")
          .first()
          .removeClass("visually-hidden")
          .clone()
          .appendTo(parentSelector + " .toggle-target-container");
      }
      $(parentSelector + " .filter-group__item").each(function (index) {
        $(this)
          .find(".filter-group__checkbox")
          .attr("value", vals[index].value);
        $(this).find(".filter-group__item__text").text(vals[index].name);
      });
    } else {
      if ($(parentSelector + " .filter-group__item.visually-hidden").length) {
        $(parentSelector).addClass("visually-hidden");
      }
    }
  }

  var $grid = "";

  function generateFilters() {
    if (
      $(".template-collection .product-list, .template-search .product-list")
        .length
    ) {
      $grid = $(".product-list").isotope({
        itemSelector: ".product-block",
        transitionDuration: 0,
        getSortData: {
          title: function (itemElem) {
            var title = $(itemElem)
              .find(".product-block__title")
              .text()
              .toLowerCase();
            return title;
          },
          price: function (itemElem) {
            var price = Number($(itemElem).data("price"));
            return price;
          },
        },
        // sort by title then price
        sortBy: ["title", "price"],
      });
      $grid.on("arrangeComplete", function (event, filteredItems) {
        for (var i = 0; i < filteredItems.length; i++) {
          $(filteredItems[i].element).css("order", i);
        }
      });
    }

    var colorsArr = [];
    var inseamsArr = [];
    var sizesArr = [];

    if ($(".product-filtering-info[data-option-colors]").length) {
      colorsArr = getCheckboxesList("color");
      generateCheckboxes("color", colorsArr);
    } else {
      generateCheckboxes("color", false);
    }
    if ($(".product-filtering-info[data-option-inseams]").length) {
      inseamsArr = getCheckboxesList("inseam");
      generateCheckboxes("inseam", inseamsArr);
    } else {
      generateCheckboxes("inseam", false);
    }
    if ($(".product-filtering-info[data-option-sizes]").length) {
      sizesArr = getCheckboxesList("size");
      var handlesArr = [];
      for (var i = 0; i < sizesArr.length; i++) {
        handlesArr.push(sizesArr[i].value);
      }
      var foundIDs = [];
      var sizesList = [];
      var orderedSizes = $(".filter-group--size")
        .data("sizes-order")
        .split("--");
      for (var i = 0; i < orderedSizes.length; i++) {
        var foundPosition = handlesArr.indexOf(orderedSizes[i]);
        if (foundPosition != -1) {
          sizesList.push(sizesArr[foundPosition]);
          foundIDs.push(foundPosition);
        }
      }
      for (var i = 0; i < sizesArr.length; i++) {
        if (foundIDs.indexOf(i) == -1) sizesList.push(sizesArr[i]);
      }
      generateCheckboxes("size", sizesList);
    } else {
      generateCheckboxes("size", false);
    }

    $(".filter-group__checkbox").on("click", function (event) {
      filterItems();
    });
    $(".cc-price-range__input").on("change", function (event) {
      filterItems();
    });
    $(".filter-toggle__input").change(function () {
      filterItems();
    });

    $(".link-dropdown__link").on("click", function (e) {
      $(".link-dropdown__button-text").text($(this).text());
      $(".link-dropdown__link").removeClass("link-dropdown__link--active");
      $(this).addClass("link-dropdown__link--active");
      sortItems($(this).attr("href"));
      e.preventDefault();
      var $radios = $("input:radio[name=sort_by]");
      $radios
        .filter("[value=" + $(this).attr("href") + "]")
        .prop("checked", true);
    });
    $(".link-dropdown__link").first().trigger("click");

    $("input[type=radio][name=sort_by]").change(function () {
      $(".link-dropdown__link[href=" + this.value + "]").trigger("click");
    });

    $(".filter-group__clear-link-kh").on("click", function (e) {
      e.preventDefault();
      $(".filter-group__checkbox:checked").prop("checked", false);
      $(".filter-group--applied").addClass("visually-hidden");
      filterItems();
    });
  }

  function sortItems(type) {
    //title-ascending title-descending price-ascending price-descending
    var order = type.indexOf("ascending") != -1;
    var typeSort = type.split("-")[0] == "title" ? "title" : "price";
    $grid.isotope({
      sortBy: typeSort,
      sortAscending: order,
    });
  }

  function filterItems() {
    var minPrice =
      $(".cc-price-range__input--min").val() != ""
        ? Number($(".cc-price-range__input--min").val())
        : 0;
    var maxPrice =
      $(".cc-price-range__input--max").val() != ""
        ? Number($(".cc-price-range__input--max").val())
        : Number($(".cc-price-range__input--max").attr("max"));

    var checkedItems = $(
      ".filter-group--color .filter-group__checkbox:checked, .filter-group--inseam .filter-group__checkbox:checked, .filter-group--size .filter-group__checkbox:checked"
    );
    if (checkedItems.length) {
      var appliedFiltersContainer = $(".filter-group.filter-group--applied");
      var modelFilterItem = $(
        ".filter-group.filter-group--applied .filter-group__applied-item-kh"
      ).first();
      appliedFiltersContainer.removeClass("visually-hidden");
      $(".filter-group__applied-item-kh:not(:first-of-type)").remove();
      checkedItems.each(function () {
        var optionName = $(this).next().text();
        var optionVal = $(this).val();
        var buttonSelector = $(".filter-group__applied-item-kh")
          .first()
          .clone()
          .removeClass("visually-hidden")
          .insertBefore(".filter-group__clear-row");
        var dataItem = buttonSelector.find(".filter-group__applied-item__text");
        dataItem.text(optionName);
        dataItem.parent().attr("data-val", optionVal);
        dataItem.parent().on("click", function (e) {
          $(
            '.filter-group__checkbox[value="' +
              $(this).data("val") +
              '"]:checked'
          ).prop("checked", false);
          if ($(".filter-group__items").children().length == 3)
            appliedFiltersContainer.addClass("visually-hidden");
          $(this).remove();
          filterItems();
          e.preventDefault();
        });
      });
    } else {
      $(".filter-group.filter-group--applied").addClass("visually-hidden");
    }

    $grid.isotope({
      filter: function () {
        if (
          $(".filter-toggle__input:checked").val() == "1" &&
          $(this).data("availability") == false
        )
          return false;
        var productPrice = Number($(this).data("price"));
        if (productPrice < minPrice || productPrice > maxPrice) return false;

        var filterItem = $(this);

        var colorsChecked = $(".filter-group--color").find(
          ".filter-group__checkbox:checked"
        );
        var hasColor = false;
        if (colorsChecked.length) {
          colorsChecked.each(function () {
            if (filterItem.hasClass($(this).val())) {
              hasColor = true;
            }
          });
          if (hasColor == false) return false;
        } else hasColor = true;

        var inseamsChecked = $(".filter-group--inseam").find(
          ".filter-group__checkbox:checked"
        );
        var hasInseam = false;
        if (inseamsChecked.length) {
          inseamsChecked.each(function () {
            if (filterItem.hasClass($(this).val())) {
              hasInseam = true;
            }
          });
          if (hasInseam == false) return false;
        } else hasInseam = true;

        var sizesChecked = $(".filter-group--size").find(
          ".filter-group__checkbox:checked"
        );
        var hasSize = false;
        if (sizesChecked.length) {
          sizesChecked.each(function () {
            if (filterItem.hasClass($(this).val())) {
              hasSize = true;
            }
          });
          if (hasSize == false) return false;
        } else hasSize = true;

        return hasColor && hasInseam && hasSize;
      },
    });
  }

  function setGridForFiltering() {
    $(".product-block").each(function () {
      var filteringInfo = $(this).find(".product-filtering-info");
      if (filteringInfo.length) {
        var classesToAdd = "";
        if (filteringInfo.data("option-colors")) {
          var optionColors = filteringInfo
            .data("option-colors")
            .split("--")
            .join(" ");
          classesToAdd += optionColors;
        }
        if (filteringInfo.data("option-inseams")) {
          classesToAdd += classesToAdd == "" ? "" : " ";
          var optionInseams = filteringInfo
            .data("option-inseams")
            .split("--")
            .join(" ");
          classesToAdd += optionInseams;
        }
        if (filteringInfo.data("option-sizes")) {
          classesToAdd += classesToAdd == "" ? "" : " ";
          var optionSizes = filteringInfo
            .data("option-sizes")
            .split("--")
            .join(" ");
          classesToAdd += optionSizes;
        }

        $(this).addClass(classesToAdd);

        $(this).attr("data-availability", filteringInfo.data("availability"));
        var productPrice = filteringInfo.data("price");
        $(this).attr("data-price", productPrice);
      }
    });
  }

  function initCollectionSelect() {
    $(".collection-select").change(function (e) {
      var val = $(this).children("option:selected").val();
      if (val != "") window.top.location.href = val;
    });
  }

  function setHideHover() {
    $(".product-block-options__inner").hover(function (e) {
      $(e.currentTarget)
        .closest(".block-inner-inner")
        .find(".collection__image-with-hover-slider")
        .hide();
    });
    $('div[data-section-type="collection-template"]').on(
      "touchmove.productBlockManager",
      ".image-cont--with-secondary-image",
      function (evt) {
        if (theme.productBlockTouchTracking) {
          $(this)
            .closest(".product-block")
            .find(".collection__image-with-hover-slider")
            .hide();
        }
      }
    );
  }

  function initializeCollection() {
    watchForQuickbuy();
    setGridForFiltering();
    generateFilters();
    setHideHover();
  }

  function initZoomImage() {
    var imageWrappers = $(".product-media--image .rimage-wrapper");
    if (imageWrappers.length) {
      imageWrappers.each(function () {
        var imageItem = $(this).find(".rimage__image");
        var zoomPercent = 150;
        var zoomDifference = zoomPercent - 100;
        var halfZoomDifference = zoomDifference / 2;
        var initWidth = imageItem.width();
        var initHeight = imageItem.height();
        $(this)
          .on("mousemove", function (e) {
            if (window.innerWidth <= 768) return;
            var x =
              e.pageX -
              this.closest(".main-image").offsetLeft -
              this.closest(".product-column-left").offsetLeft;
            var y =
              e.pageY -
              this.closest(".main-image").offsetTop -
              this.closest(".product-column-left").offsetTop;
            var xpercent = x / initWidth;
            var ypercent = y / initHeight;
            imageItem.css({
              left: halfZoomDifference - xpercent * zoomDifference + "%",
            });
            imageItem.css({
              top: halfZoomDifference - ypercent * zoomDifference + "%",
            });
          })
          .on("mouseenter", function () {
            initWidth = imageItem.width();
            initHeight = imageItem.height();
            if (window.innerWidth <= 768) return;
            imageItem.css("transform", "scale(" + zoomPercent / 100 + ")");
          })
          .on("mouseleave", function () {
            imageItem.css("transform", "initial");
            imageItem.css({ left: "0" });
            imageItem.css({ top: "0" });
          });
      });
    }
  }

  if ($(".template-collection").length || $(".template-search").length) {
    $(window).on("load", function () {
      initializeCollection();
      initCollectionSelect();
    });
  }

  if ($(".template-product").length || $(".template-index").length) {
    watchForQuickbuy();
  }

  if ($(".template-product").length) {
    initZoomImage();
  }

  if ($(".product-block-options__item").length) {
    $(".product-block-options__item").each(function (index) {
      $(this).mouseover(function () {
        var linkItem = $(this)
          .parents(".block-inner-inner")
          .find(".product-link");
        var hrefValue = linkItem.attr("href");
        var hrefRoot =
          hrefValue.indexOf("?selected-handle=") != -1
            ? hrefValue.split("?selected-handle=")[0]
            : hrefValue;
        linkItem.attr(
          "href",
          hrefRoot + "?selected-handle=" + $(this).attr("data-option-item")
        );
      });
    });
  }

  $(window).bind("unload", function () {
    if ($(".collection-select").length) {
      $(".collection-select").val("");
    }
  });

  const ele = document.getElementById("container-drag");

  let pos = { top: 0, left: 0, x: 0, y: 0 };

  const mouseDownHandler = function (e) {
    ele.style.cursor = "grabbing";
    ele.style.userSelect = "none";

    pos = {
      // The current scroll
      left: ele.scrollLeft,
      top: ele.scrollTop,
      // Get the current mouse position
      x: e.clientX,
      y: e.clientY,
    };

    e.preventDefault();
    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);
  };

  const mouseMoveHandler = function (e) {
    // How far the mouse has been moved
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    // Scroll the element
    ele.scrollTop = pos.top - dy;
    const posX = pos.left - dx;
    ele.scrollLeft = posX;
  };

  const mouseUpHandler = function () {
    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);

    ele.style.cursor = "grab";
    ele.style.removeProperty("user-select");
  };

  if (ele) ele.addEventListener("mousedown", mouseDownHandler);

  const sectionStoreMessages = $("#shopify-section-store-messages");
  if (sectionStoreMessages) {
    const placeStoreMessageTop = function () {
      const shopifySectionHeader = $("#shopify-section-header");
      shopifySectionHeader &&
        sectionStoreMessages.css({
          top: `${shopifySectionHeader.outerHeight()}px`,
        });
    };
    $(window).on("load", function () {
      placeStoreMessageTop();
    }),
      $(window).on("scroll", function () {
        placeStoreMessageTop();
      }),
      $(window).on("resize", function () {
        placeStoreMessageTop();
      });
  }

  /*** Kaching Bundles validation START ***/
  function initKachingBundlesValidation() {
    console.log('[Kaching Bundle] initKachingBundlesValidation called');
    // Check if we have the kaching bundle selector on this page
    if ($(".kaching-bundles__multiple-gifts-selector__clickable-overlay").length) {
      console.log('[Kaching Bundle] Bundle selector found on page');
      var $productForm = $(".product-purchase-form");
      var $addToCartBtn = $productForm.find('button[type="submit"]');

      console.log('[Kaching Bundle] Product form:', $productForm.length, 'Add to cart button:', $addToCartBtn.length);

      if ($productForm.length && $addToCartBtn.length) {
        // Add warning element if not exists
        if (!$(".kaching-bundle-warning").length) {
          console.log('[Kaching Bundle] Adding warning element');
          $productForm.before('<div class="kaching-bundle-warning" style="display:none; color: #c0392b; background: #fde8e8; border: 1px solid #e74c3c; padding: 12px 16px; margin-bottom: 12px; border-radius: 4px; font-size: 14px;"><strong>Please select your Combo Set</strong><br><span style="font-weight: normal;">You need to choose a pant from the bundle before adding to cart.</span></div>');
        }

        // Use jQuery to attach click handler
        $addToCartBtn.on('click.kachingValidation', function(e) {
          console.log('[Kaching Bundle] Button clicked');

          // Check if kaching bundle selector exists
          if ($(".kaching-bundles__multiple-gifts-selector__clickable-overlay").length) {
            console.log('[Kaching Bundle] Kaching bundle UI detected, checking selection status...');

            // There are 2 radio options: (1) "Top Only" - non-bundle, (2) "Combo Set" - bundle
            // Check if SECOND radio (.kaching-bundles__bar) has --selected class
            var $secondRadio = $(".kaching-bundles__bar").eq(1); // 0-indexed, so eq(1) is the second one
            var secondRadioSelected = $secondRadio.hasClass('kaching-bundles__bar--selected');
            console.log('[Kaching Bundle] Second radio selected:', secondRadioSelected);

            if (secondRadioSelected) {
              // Radio 2 (Combo Set) selected - need to check if product is chosen
              var $footerText = $(".kaching-bundles__free-gift__text");
              var footerText = $footerText.text().trim();
              console.log('[Kaching Bundle] Footer text:', footerText);

              // Check if product is selected - text should match "X Pant selected" pattern
              var productSelected = false;
              if ($footerText.length > 0) {
                var match = footerText.match(/(\d+)\s*Pants?\s*selected/);
                if (match && parseInt(match[1]) > 0) {
                  productSelected = true;
                  console.log('[Kaching Bundle] Product selected, count:', match[1]);
                }
              }

              if (!productSelected) {
                console.log('[Kaching Bundle] Bundle mode but NO product chosen - showing warning');
                e.preventDefault();
                e.stopImmediatePropagation();
                $(".kaching-bundle-warning").fadeIn();
                $('html, body').animate({
                  scrollTop: $(".kaching-bundle-warning").offset().top - 100
                }, 300);
                return false;
              } else {
                console.log('[Kaching Bundle] Bundle product selected - passing validation');
                $(".kaching-bundle-warning").fadeOut();
              }
            } else {
              // Radio 1 selected - pass
              console.log('[Kaching Bundle] Non-bundle product selected - passing validation');
              $(".kaching-bundle-warning").fadeOut();
            }
          } else {
            console.log('[Kaching Bundle] No kaching bundle selector found, allowing add to cart');
            $(".kaching-bundle-warning").fadeOut();
          }
          // Let the event continue to theme JS handlers
        });

        // Also listen for clicks on bundle selector to hide warning when user selects
        $(document).on('click.kachingBundle', '.kaching-bundles__multiple-gifts-selector__clickable-overlay, .kaching-bundles__free-gift__text', function() {
          console.log('[Kaching Bundle] User clicked on bundle selector');
          $(".kaching-bundle-warning").fadeOut();
        });
      }
    } else {
      console.log('[Kaching Bundle] No bundle selector found on page');
    }
  }

  // Run on document ready
  $(document).ready(initKachingBundlesValidation);

  // Also try after a delay in case kaching loads dynamically
  setTimeout(initKachingBundlesValidation, 2000);

  // Watch for quickbuy container
  if ($(".quickbuy-container").length) {
    var kachingObserver = new MutationObserver(function(mutations) {
      console.log('[Kaching Bundle] Quickbuy DOM changed');
      if ($(".kaching-bundles__multiple-gifts-selector__clickable-overlay").length) {
        console.log('[Kaching Bundle] Bundle selector detected in quickbuy');
        initKachingBundlesValidation();
      }
    });
    kachingObserver.observe($(".quickbuy-container")[0], { childList: true, subtree: true });
  }
  /*** Kaching Bundles validation END ***/
  
})(theme.jQuery);
